import React from 'react';
import Table from '../components/Table/Table';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import FileOpenIcon from '@material-ui/icons/OpenInNew';
import { Tooltip, IconButton } from '@material-ui/core';
import { totalRangeDishStatisticsRoute } from 'routes';

const reportData = [
  { number: 1, name: 'Total range dish statistics', action: 1 }
];

const ReportsListView = () => {
  const ReportColumns = {
    Number: {
      name: 'number',
      label: 'Number',
      dataField: 'number',
      //   filterable: true,
      sortable: false,
      width: 90,
      grow: 0,
      shrink: 0
    },
    ReportName: {
      name: 'name',
      dataField: 'name',
      sortable: true,
      label: 'Report name',
      width: 280,
      grow: 0,
      shrink: 0
    },
    Actions: {
      name: 'action',
      label: 'Actions',
      CellValue: ({ rowData }) => {
        return (
          <Tooltip title="Open the report">
            <IconButton
              onClick={() => {
                //  return checkOutToMarket(rowData.market)
              }}
              color="secondary"
              size="medium"
            >
              <FileOpenIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
      link: rowData => totalRangeDishStatisticsRoute(rowData),
      grow: 0,
      shrink: 0,
      width: 45,
      searchable: false,
      sortable: false
    },
    EmptySpace: {
      name: 'namae',
      sortable: false,
      dataField: '',
      label: '  '
    }
  };

  // const viewPublishedPpsi = ppsi => {
  //   history.push(ppsiPublishedRoute(ppsi.id));
  // };

  View.PpsiReportView.visit();

  return (
    <PaperContainer>
      <Table
        title="ppsi.ppsiReportsTitle"
        data={reportData}
        columns={[
          ReportColumns.Number,
          ReportColumns.ReportName,
          ReportColumns.Actions,
          ReportColumns.EmptySpace
        ]}
        getObjectId={object => object.id}
        // defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        // onRowClick={viewPublishedPpsi}
      />
    </PaperContainer>
  );
};

export default ReportsListView;
